import { render, staticRenderFns } from "./LinkedIn.vue?vue&type=template&id=1c5bcd19&"
import script from "./LinkedIn.vue?vue&type=script&lang=ts&"
export * from "./LinkedIn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports